/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { AdmConnectionInfo } from "../models/adm-connection-info";
import { AdmRotateSecretResult } from "../models/adm-rotate-secret-result";
import { SharedCredentialUsage } from "../models/shared-credential-usage";
@Injectable({
  providedIn: "root",
})
class AdmConnectionService extends __BaseService {
  static readonly admConnectionGetLayoutConnectionInfoPath =
    "/api/AdmConnection/{layoutId}/ConnectionInfo";
  static readonly admConnectionGetSubscriptionConnectionInfoPath =
    "/api/AdmConnection/Subscription/{subscriptionId}/ConnectionInfo";
  static readonly admConnectionRotateLayoutSecretPath =
    "/api/AdmConnection/{layoutId}/RotateSecret";
  static readonly admConnectionRotateSubscriptionSecretPath =
    "/api/AdmConnection/Subscription/{subscriptionId}/RotateSecret";
  static readonly admConnectionGetSharedCredentialUsagePath =
    "/api/AdmConnection/SharedCredentialUsage";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param layoutId undefined
   */
  admConnectionGetLayoutConnectionInfoResponse(
    layoutId: number
  ): __Observable<__StrictHttpResponse<AdmConnectionInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdmConnection/${layoutId}/ConnectionInfo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmConnectionInfo>;
      })
    );
  }
  /**
   * @param layoutId undefined
   */
  admConnectionGetLayoutConnectionInfo(
    layoutId: number
  ): __Observable<AdmConnectionInfo> {
    return this.admConnectionGetLayoutConnectionInfoResponse(layoutId).pipe(
      __map((_r) => _r.body as AdmConnectionInfo)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  admConnectionGetSubscriptionConnectionInfoResponse(
    subscriptionId: number
  ): __Observable<__StrictHttpResponse<AdmConnectionInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl +
        `/api/AdmConnection/Subscription/${subscriptionId}/ConnectionInfo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmConnectionInfo>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  admConnectionGetSubscriptionConnectionInfo(
    subscriptionId: number
  ): __Observable<AdmConnectionInfo> {
    return this.admConnectionGetSubscriptionConnectionInfoResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as AdmConnectionInfo));
  }

  /**
   * @param layoutId undefined
   */
  admConnectionRotateLayoutSecretResponse(
    layoutId: number
  ): __Observable<__StrictHttpResponse<AdmRotateSecretResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/AdmConnection/${layoutId}/RotateSecret`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmRotateSecretResult>;
      })
    );
  }
  /**
   * @param layoutId undefined
   */
  admConnectionRotateLayoutSecret(
    layoutId: number
  ): __Observable<AdmRotateSecretResult> {
    return this.admConnectionRotateLayoutSecretResponse(layoutId).pipe(
      __map((_r) => _r.body as AdmRotateSecretResult)
    );
  }

  /**
   * @param subscriptionId undefined
   */
  admConnectionRotateSubscriptionSecretResponse(
    subscriptionId: number
  ): __Observable<__StrictHttpResponse<AdmRotateSecretResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl +
        `/api/AdmConnection/Subscription/${subscriptionId}/RotateSecret`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AdmRotateSecretResult>;
      })
    );
  }
  /**
   * @param subscriptionId undefined
   */
  admConnectionRotateSubscriptionSecret(
    subscriptionId: number
  ): __Observable<AdmRotateSecretResult> {
    return this.admConnectionRotateSubscriptionSecretResponse(
      subscriptionId
    ).pipe(__map((_r) => _r.body as AdmRotateSecretResult));
  }

  /**
   * @param days undefined
   */
  admConnectionGetSharedCredentialUsageResponse(
    days?: number
  ): __Observable<__StrictHttpResponse<Array<SharedCredentialUsage>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (days != null) __params = __params.set("days", days.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/AdmConnection/SharedCredentialUsage`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SharedCredentialUsage>>;
      })
    );
  }
  /**
   * @param days undefined
   */
  admConnectionGetSharedCredentialUsage(
    days?: number
  ): __Observable<Array<SharedCredentialUsage>> {
    return this.admConnectionGetSharedCredentialUsageResponse(days).pipe(
      __map((_r) => _r.body as Array<SharedCredentialUsage>)
    );
  }
}

module AdmConnectionService {}

export { AdmConnectionService };
